import { samoletAuthConfig } from '../config';
import type { ISIDTokenResponse, ISamoletConfiguration } from '../types';

import { authApiClient } from './client';

export async function refreshAuthToken(
  config: ISamoletConfiguration,
  refreshToken: string,
): Promise<ISIDTokenResponse> {
  const formData = new FormData();

  formData.append('grant_type', samoletAuthConfig.grantType.refresh);
  formData.append('client_id', config.clientId);
  formData.append('refresh_token', refreshToken);

  const { data } = await authApiClient.post(config.urls.getAuthTokenUrl(), formData);

  return data as ISIDTokenResponse;
}
